import React, { Component } from 'react';
import NavBar from '../../components/NavBar.jsx';
import GeckoFeatures from 'services/gecko-features';
import { connect } from 'react-redux';

class Settings extends Component {
  navLinks = [
    {
      to: '/settings/channels',
      activeClassName: 'active',
      linkText: 'Channels',
    },
    {
      to: '/settings/customfields',
      activeClassName: 'active',
      linkText: 'Custom Fields',
    },
    {
      to: '/settings/integrations',
      activeClassName: 'active',
      linkText: 'Integrations',
    },
    {
      to: '/settings/tags',
      activeClassName: 'active',
      linkText: 'Tags',
    },
    {
      to: '/settings/savedreplies',
      activeClassName: 'active',
      linkText: 'Saved Replies',
    },
    {
      to: '/settings/exports',
      activeClassName: 'active',
      linkText: 'Exports',
    },
    {
      to: '/settings/datasources',
      activeClassName: 'active',
      linkText: 'Data Sources',
      hidden: !GeckoFeatures.can('data-source'),
    },
  ];

  render() {
    const isSmallScreen = ['xs', 'sm'].indexOf(this.props.screenSize) !== -1;
    const style = {
      container: {
        height: '100%',
        display: 'flex',
      },
      navContainer: {
        height: '100%',
        background: 'rgb(126, 38, 167)',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'stretch',
        borderTop: '1px solid rgb(75, 22, 100)',
      },
      link: {
        color: 'white',
        textDecoration: 'none',
        fontSize: '1.2em',
        width: '100%',
      },
      linkContent: {
        height: '100%',
        display: 'flex',
        padding: 20,
        alignItems: 'center',
        ':hover': {
          background: 'rgb(75, 22, 100)',
        },
      },
      linkIcon: {
        marginRight: isSmallScreen ? 0 : 20,
      },
      linkText: {
        display: isSmallScreen ? 'none' : 'inline-block',
      },
      active: {
        background: 'rgb(75, 22, 100)',
      },
      routeContainer: {
        flexGrow: 2,
      },
    };
    return (
      <div>
        <NavBar navLinks={this.navLinks} showAIInsights />

        <div style={style.routeContainer}>{this.props.children}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    screenSize: state.appState.screenSize,
    account: state.appState.account,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
